import React, {useState} from 'react';
import {AreYouSureDialog} from '../dialog';
import type {ActionButtonV2Props} from './ActionButtonV2';
import {ActionButtonV2} from './ActionButtonV2';

export const ConfirmButtonV2: React.FC<
  ActionButtonV2Props & {
    doubleConfirm?: boolean;
    doubleConfirmMessage?: string;
    prevent?: string;
  }
> = ({
  title,
  onClick,
  doubleConfirm,
  doubleConfirmMessage,
  prevent,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenConfirmation = () => {
    setOpen(true);
  };

  const handleCloseConfirmation = (confirmed?: boolean) => {
    setOpen(false);

    if (confirmed) {
      onClick();
    }
  };

  return (
    <>
      <ActionButtonV2
        showSpinnerOnClick
        onClick={handleOpenConfirmation}
        title={title}
        {...props}
      />

      <AreYouSureDialog
        id="confirm-dialog"
        keepMounted={false}
        open={open}
        onClose={handleCloseConfirmation}
        doubleConfirm={doubleConfirm}
        doubleConfirmMessage={doubleConfirmMessage}
        prevent={prevent}
      />
    </>
  );
};
